module.exports = __webpack_public_path__ + "img/etc-new-arrow-top.fa699a94.svg";